import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut as firebaseSignOut } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { 
  initializeFirestore, 
  persistentLocalCache,
  getFirestore
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDc49LPNXSZa7ebqaWtHii_Hc6O30cyiGY",
  // Using the default firebaseapp domain is CRITICAL for custom domain support without manual OAuth configuration.
  // This routes the auth handshake through the pre-verified firebase domain.
  authDomain: "level-up-fitness-7835e.firebaseapp.com",
  databaseURL: "https://level-up-fitness-7835e-default-rtdb.firebaseio.com",
  projectId: "level-up-fitness-7835e",
  storageBucket: "level-up-fitness-7835e.firebasestorage.app",
  messagingSenderId: "176850202416",
  appId: "1:176850202416:web:8bcd73fb5fe42e2f71e2f5",
  measurementId: "G-WE4VC0T3B6"
};

// Initialize Firebase
let app;
let auth: any;
let googleProvider: any;
let db: any;

try {
  console.log("Initializing Firebase Core...");
  app = initializeApp(firebaseConfig);
  console.log("Firebase App initialized successfully");
  
  // Initialize Analytics safely
  try {
    getAnalytics(app);
  } catch (e) {
    console.warn("Firebase Analytics could not be initialized (optional module).");
  }

  try {
    auth = getAuth(app);
    console.log("Firebase Auth Service Online");
    googleProvider = new GoogleAuthProvider();
  } catch (authErr: any) {
    console.error("Critical: Firebase Auth failed to initialize.", authErr);
    if (authErr.message?.includes("not been registered")) {
       console.error("DEPENDENCY MISMATCH: Ensure all firebase modules in index.html importmap are using the EXACT same version (e.g. 10.8.0).");
    }
  }
  
  // Initialize Firestore with offline persistence enabled.
  try {
    // Attempt to initialize with persistence
    db = initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: undefined 
      })
    });
    console.log("Firebase Firestore initialized with persistence");
  } catch (err: any) {
    console.warn("Firestore persistence initialization failed, attempting fallback:", err.message);
    
    // If it's already initialized or failed, try getting the default instance
    try {
       db = getFirestore(app);
       console.log("Firebase Firestore retrieved (fallback/standard mode)");
    } catch (fallbackErr: any) {
       console.error("Critical: Firestore completely failed to initialize.", fallbackErr);
    }
  }

} catch (e) {
  console.error("Firebase Initialization Error:", e);
}

export { auth, googleProvider, db };

export const signInWithGoogle = async () => {
  if (!auth) throw new Error("Firebase Auth not initialized. Check console for 'Auth failed to initialize' errors.");
  try {
    await signInWithPopup(auth, googleProvider);
  } catch (error) {
    console.error("Error signing in with Google", error);
    throw error;
  }
};

export const signOut = async () => {
  if (!auth) return;
  try {
    await firebaseSignOut(auth);
  } catch (error) {
    console.error("Error signing out", error);
  }
};
